import api from 'services/api';

export async function getDepartments({ organizationId }: { organizationId: string }) {
  const response = await api.get(
    `api/dashboard/organizations/${organizationId}/departments`,
  );
  return response;
}
